<template>
  <div>
    <el-card>
      <div slot="header">{{ $ct('unit_menuName[20]') }}</div>
      <search-form @getData="getData"/>
      <unit-table :data="data" :loading="loading" @getData="getData"/>
    </el-card>
  </div>
</template>
<script>
import SearchForm from './searchForm'
import unitTable from './unitTable'
export default {
  components: {
    SearchForm,
    unitTable
  },
  data() {
    return {
      data: [],
      loading: false
    }
  },
  computed: {
    role_id() {
      return this.$store.state.user.role_id
    }
  },
  methods: {
    // 获取数据
    async getData() {
      // this.loading = true;
      const res = await this.$store.dispatch('unitManageGetData')
      // this.loading = false;
      if (res.status < 400) {
        this.data = res.data.items
      }
    }
  },
  mounted() {
    this.$store.commit('unitManageInit')
    this.getData()
  }
}
</script>
